export const isValidVehicleType = (type) => {
  const t = type.replace(/\s/g, '_');
  return t === 'MOTO' ||
    t.includes('MOTO') ||
    t === 'CAMION' ||
    t === 'TRACTOR' ||
    t === 'BUS' ||
    t === 'CHASIS_CABINADO' ||
    t === 'FURGON' ||
    t === 'MAQUINA_AGRICOLA' ||
    t === 'MAQUINA_INDUSTRIAL';
}
